import { Outlet } from 'react-router'
import { SiteFooter } from './SiteFooter'
import { SiteHeader } from './SiteHeader'
import { SiteSearchProvider } from '../search/SiteSearch'

export function SiteLayout() {
  return (
    <SiteSearchProvider><div className="site-frame">
      <SiteHeader />
      <main id="content">
        <Outlet />
      </main>
      <SiteFooter />
    </div></SiteSearchProvider>
  )
}
